import React from 'react'
import PropTypes from 'prop-types'
import {Box, Flex, Img, useMultiStyleConfig} from '@chakra-ui/react'
import useDamImage from '../../../custom-hooks/use-dam-image'
import parse from 'html-react-parser'

export const FaqsBanner = ({bodycopy = '', heading = '', icon}) => {
    const styles = useMultiStyleConfig('Faq', {})
    const {bannerFaqStyles} = styles || null

    const damImage = useDamImage(icon)

    return (
        <Box {...bannerFaqStyles.bannerContainer}>
            <Flex {...bannerFaqStyles.bannerGrid}>
                {damImage.url && (
                    <Box {...bannerFaqStyles.bannerIcon}>
                        <Img w={'100%'} src={damImage.url} alt={icon?.description || ''}></Img>
                    </Box>
                )}
                <Flex {...bannerFaqStyles.bannerContent}>
                    <Box data-testid="faqs-banner-heading" {...bannerFaqStyles.bannerHeading}>
                        {parse(heading)}
                    </Box>
                    <Box
                        data-testid="faqs-banner-bodycopy"
                        sx={{
                            a: {
                                color: 'text.tertiary',
                                textDecoration: 'underline',
                                fontWeight: 'normal',
                            },
                        }}
                        {...bannerFaqStyles.bannerBodycopy}
                    >
                        {parse(bodycopy)}
                    </Box>
                </Flex>
            </Flex>
        </Box>
    )
}

FaqsBanner.propTypes = {
    heading: PropTypes.string,
    bodycopy: PropTypes.string,
    icon: PropTypes.shape(),
}
